import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useFooter } from './FooterContext';
import { AppRoute } from '../../../constants/route';
import { generateLocaleRoute } from '../../../utils/uri/uri.utils';
import { useStore } from '../../../stores/store';
import { client } from '../../../config';

const noFooterAuthScreens = ['welcome-old-account', 'welcome-social-account'];

const FooterVisibilityHandler = () => {
  const location = useLocation();
  const { setFooterDisplayOption } = useFooter();

  const {
    localizationsStore: { localeParam },
    navStore: { authCurrentScreen },
  } = useStore();

  useEffect(() => {
    const path = location.pathname;
    const isPolonez = client === 'polonez';
    const isMainPage = path === generateLocaleRoute(undefined, localeParam);

    const isParcelCreationFlow = path.includes(AppRoute.PARCEL_CREATE);
    const isNoFooterAuthScreen =
      noFooterAuthScreens.includes(authCurrentScreen);

    const isMySection = path.includes(AppRoute.MY);
    const isPrivacyPage = path.includes(AppRoute.PRIVACY_OPT_OUT);

    // Polonez footer
    if (isPolonez) {
      if (isMySection || isPrivacyPage) {
        setFooterDisplayOption('full');
        return;
      }

      setFooterDisplayOption('hidden');
      return;
    }

    // Meest footer
    if (isMainPage) {
      setFooterDisplayOption('full');
      return;
    }

    if (isParcelCreationFlow || isNoFooterAuthScreen) {
      setFooterDisplayOption('hidden');
      return;
    }

    setFooterDisplayOption('mini');
  }, [
    location.pathname,
    localeParam,
    setFooterDisplayOption,
    authCurrentScreen,
  ]);

  return null;
};

export default observer(FooterVisibilityHandler);
